import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isImpersonationRuntimeEnabled } from '../../_services/impersonation-runtime';
import { VOUCHER_DEMO_STORAGE_KEY } from './voucher-demo.constants';
import * as i0 from "@angular/core";
var VoucherDemoModeService = /** @class */ (function () {
    function VoucherDemoModeService() {
        this.runtimeAllowed = !environment.production;
        this.enabledSubject = new BehaviorSubject(this.runtimeAllowed && this.readFromStorage());
        this.enabled$ = this.enabledSubject.asObservable();
    }
    /**
     * Production Angular builds only honor the demo toggle on local/staging hosts.
     * Call after config.json loads so a leftover localStorage flag cannot fire on prod.
     */
    VoucherDemoModeService.prototype.enableForRuntime = function (host, productionBuild) {
        if (productionBuild === void 0) { productionBuild = environment.production; }
        this.runtimeAllowed = isImpersonationRuntimeEnabled(productionBuild, host);
        this.enabledSubject.next(this.runtimeAllowed && this.readFromStorage());
    };
    VoucherDemoModeService.prototype.isEnabled = function () {
        return this.runtimeAllowed && this.enabledSubject.value;
    };
    VoucherDemoModeService.prototype.setEnabled = function (enabled) {
        if (enabled && !this.runtimeAllowed) {
            return;
        }
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem(VOUCHER_DEMO_STORAGE_KEY, enabled ? 'true' : 'false');
        }
        this.enabledSubject.next(this.runtimeAllowed && enabled);
    };
    VoucherDemoModeService.prototype.readFromStorage = function () {
        if (typeof window === 'undefined' || !window.localStorage) {
            return false;
        }
        return window.localStorage.getItem(VOUCHER_DEMO_STORAGE_KEY) === 'true';
    };
    VoucherDemoModeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VoucherDemoModeService_Factory() { return new VoucherDemoModeService(); }, token: VoucherDemoModeService, providedIn: "root" });
    return VoucherDemoModeService;
}());
export { VoucherDemoModeService };
